const url = "/api/v1/delayed_password";

export interface DelayedPasswordCreateParams {
  password: string;
}

export const delayedPasswordCreateQuery = (
  params: DelayedPasswordCreateParams,
) => ({
  url,
  method: "POST",
  body: params,
});
